import { useQuery } from '@apollo/client';

import UserSummaryTray from '@atom/components/mapPortal/userSummary/UserSummaryTray';
import { GET_USER } from '@atom/graph/user';
import { GET_WORK_ORDERS } from '@atom/graph/work';
import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';
import { UserDetail } from '@atom/types/user';
import {
  WorkOrdersConnection,
  WorkOrdersConnectionInput,
} from '@atom/types/work';

const UserSummaryWrapper = () => {
  const [{ id }, { updateSearchParams }] = useNavigation({
    id: SearchParamType.STRING,
  });

  const { data: userData, loading: loadingGetUser } = useQuery<
    { user: UserDetail },
    { id: string }
  >(GET_USER, {
    variables: {
      id,
    },
    fetchPolicy: 'no-cache',
  });

  const { data: workOrdersData, loading: loadingGetWorkOrders } = useQuery<
    { workOrders: WorkOrdersConnection },
    { input: WorkOrdersConnectionInput }
  >(GET_WORK_ORDERS, {
    variables: {
      input: {
        userIds: [id],
        sortBy: 'dueDate,asc',
        page: 1,
        limit: 250,
        statusIds: [1, 2, 3, 4],
      },
    },
    fetchPolicy: 'no-cache',
  });

  return (
    <UserSummaryTray
      user={userData?.user}
      loading={loadingGetUser || loadingGetWorkOrders}
      workOrders={workOrdersData?.workOrders?.workOrders}
      onCancel={() => updateSearchParams({ view: 'layers' })}
    />
  );
};

export default UserSummaryWrapper;
